module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.b58f468.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.eot
// module id = 1uWz
// module chunks = 0